export default "__VITE_ASSET__BTu78jkZ__"